export default {
  time: {
    hhmmss: {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    },
  },
  date: {
    hhmmss: {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    },
  },
  number: {
    temperature: {
      minimumFractionDigits: 1,
      style: 'unit',
      unit: 'celsius',
    },
    compact: { notation: 'compact' },
    kg: {
      style: 'unit',
      unit: 'kilogram',
    },
    EUR: {
      style: 'currency',
      currency: 'EUR',
    },
    USD: {
      style: 'currency',
      currency: 'USD',
    },
  },
};
